import { createContext, useContext } from 'react';

/* eslint-disable react-refresh/only-export-components -- context + hook share one module */

/** True when `PublicMarketingLayout` owns nav + atmosphere for this tree. */
export const PublicMarketingChromeContext = createContext(false);

export function usePublicMarketingChrome() {
  return useContext(PublicMarketingChromeContext);
}
